/**
 * DeleteStyleDialog — Modal "Borrar Estilo"
 *
 * Extraído de App.js líneas 9633-9673 durante la Ola D del refactor 2026-02.
 * Selector para eliminar un estilo musical existente de la biblioteca.
 */

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Label } from './ui/label';
import { Button } from './ui/button';

export const DeleteStyleDialog = ({
  isOpen,
  onOpenChange,
  selectedGenreToDelete,
  setSelectedGenreToDelete,
  genres,
  onDelete,
}) => {
  const handleCancel = () => {
    onOpenChange(false);
    setSelectedGenreToDelete('');
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent
        className="w-[95vw] max-w-md bg-slate-900 text-slate-100 border-slate-700"
        data-testid="delete-style-dialog"
      >
        <DialogHeader>
          <DialogTitle>Borrar Estilo</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <Label>Selecciona el estilo a eliminar</Label>
          <select
            value={selectedGenreToDelete}
            onChange={(e) => setSelectedGenreToDelete(e.target.value)}
            className="w-full p-2 bg-slate-800 border border-slate-700 rounded"
            data-testid="delete-style-select"
          >
            <option value="">Selecciona un estilo...</option>
            {genres.map((genre) => (
              <option key={genre} value={genre}>
                {genre}
              </option>
            ))}
          </select>
          <div className="flex gap-2 justify-end">
            <Button
              variant="outline"
              onClick={handleCancel}
              className="border-slate-600 hover:bg-slate-800"
              data-testid="delete-style-cancel-btn"
            >
              Cancelar
            </Button>
            <Button
              onClick={onDelete}
              className="bg-red-600 hover:bg-red-700"
              disabled={!selectedGenreToDelete}
              data-testid="delete-style-submit-btn"
            >
              Borrar
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteStyleDialog;
